import React from "react";
import { CSVLink } from "react-csv";
import "./CustomDownloadButton.css";
function CustomDownloadButton(props) {
  return (
    <>
      {props.f_type == "pdf" ? (
        <button
          className="primaryButton download-csv-link"
          style={{ border: "none" }}
        >
          <span className="material-icons align-middle text-white">
            {props.iconName}
          </span>
          {props.csvName}
        </button>
      ) : (
        <CSVLink
          data={props.csvListData}
          headers={props.headers}
          filename={props.filename}
          className="primaryButton  download-csv-link"
        >
          <span className="material-icons align-middle text-white">
            {props.iconName}
          </span>

          {props.csvName}
        </CSVLink>
      )}
    </>
  );
}

export default CustomDownloadButton;
